"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = __importDefault(require("../../client"));
const path = (id) => `/event/${id}/score`;
function updateScore(auth, event, player, round, score, sign = false) {
    const eventId = event.split(':')[1];
    const data = {
        player,
        round,
        score,
        sign,
    };
    return client_1.default.put(path(eventId), data, {
        headers: {
            Authorization: auth,
        },
    });
}
exports.default = updateScore;
